import { render, staticRenderFns } from "./CostDistribution.vue?vue&type=template&id=3caf41ac&"
import script from "./CostDistribution.vue?vue&type=script&lang=js&"
export * from "./CostDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports